import { M8PartnerCancelledClientDTO } from 'services/production/types';
import { normalizeM8CompanySize } from 'services/production/utils/normalizeM8CompanySize';
import {
  PartnerClientsTableItem,
  PartnerClientSubscription,
} from 'types/partnerClientsTable';
import { UnexpectedError } from 'utils/errors';
import { normalizeM8DateString } from './normalizeM8DateString';

export const normalizeM8PartnerCancelledClientDTO = (
  m8PartnerCancelledClientDTO: M8PartnerCancelledClientDTO
) => ({
  toPartnerClientsTableItem(): PartnerClientsTableItem {
    const subscription = normalizeM8PartnerCancelledClientDTO(
      m8PartnerCancelledClientDTO
    ).toPartnerClientSubscription();

    return {
      id: m8PartnerCancelledClientDTO.id,
      organization: m8PartnerCancelledClientDTO.organization,
      firstName: m8PartnerCancelledClientDTO.firstName,
      middleName: m8PartnerCancelledClientDTO.middleName,
      lastName: m8PartnerCancelledClientDTO.lastName,
      position: m8PartnerCancelledClientDTO.position,
      phone: m8PartnerCancelledClientDTO.phoneNumber,
      orgSize: m8PartnerCancelledClientDTO.companySize
        ? normalizeM8CompanySize(
            m8PartnerCancelledClientDTO.companySize
          ).toOrgStaffCount()
        : 'small',
      licensesCount: m8PartnerCancelledClientDTO.licensesCount,
      income: {
        amount: 0,
        monthly: false,
      },
      subscription,
      debitStatus: null,
      willBeDeletedInDays: m8PartnerCancelledClientDTO.willBeLostAfter || 0,
    };
  },
  toPartnerClientSubscription(): PartnerClientSubscription {
    const {
      subscription: { date },
    } = m8PartnerCancelledClientDTO;

    if (date) {
      const cancellationDateISO = normalizeM8DateString(date)
        .toDate()
        .toISOString();

      return {
        status: 'CANCELLED',
        cancellationDateISO,
      };
    }

    throw new UnexpectedError();
  },
});
